
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trophies/[trophyId]",
      function () {
        return require("private-next-pages/trophies/[trophyId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trophies/[trophyId]"])
      });
    }
  